import React from 'react'
import { useLocation } from 'react-router-dom'
import { Check } from 'lucide-react'
import { useCampaign } from '@/hooks/useCampaign'
import { cn } from '@/lib/utils'

const steps = ['Basics', 'Creative brief', 'Review & create']

/** 1 — 2 — 3 across the top of the campaign wizard; finished steps can be revisited */
const CampaignStepper: React.FC = () => {
  const { goToStep } = useCampaign()
  const { pathname } = useLocation()
  const current = Number(pathname.match(/\/campaign\/create\/step(\d+)/)?.[1] ?? 1)

  return (
    <ol className="mx-auto mb-8 flex max-w-3xl items-start">
      {steps.map((name, i) => {
        const n = i + 1
        const done = n < current
        const on = n === current
        return (
          <li key={name} className="relative flex flex-1 flex-col items-center">
            {i > 0 ? (
              <span
                className={cn(
                  'absolute right-1/2 top-4 h-0.5 w-full -translate-y-1/2',
                  n <= current ? 'bg-[#111827]' : 'bg-border',
                )}
              />
            ) : null}
            <button
              type="button"
              onClick={() => done && goToStep(n)}
              disabled={!done}
              aria-current={on ? 'step' : undefined}
              className={cn(
                'relative z-10 flex h-8 w-8 items-center justify-center rounded-full text-sm font-semibold',
                done || on
                  ? 'bg-[#111827]'
                  : 'border-2 border-border bg-card text-muted-foreground',
                on && 'ring-4 ring-[#C0FD72]',
              )}
              style={done || on ? { color: '#fff' } : undefined}
            >
              {done ? <Check className="h-4 w-4" strokeWidth={3} /> : n}
            </button>
            <span
              className={cn(
                'mt-2 text-center text-xs font-bold uppercase tracking-wider',
                on ? 'text-foreground' : 'text-muted-foreground',
              )}
            >
              {name}
            </span>
          </li>
        )
      })}
    </ol>
  )
}

export default CampaignStepper
